/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingnicknameshint2Inputs */

const en_listingnicknameshint2 = /** @type {(inputs: Listingnicknameshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separate several with commas. When someone calls you that in a plan, Pulsify finds your place.`)
};

const de_listingnicknameshint2 = /** @type {(inputs: Listingnicknameshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrere mit Komma trennen. Nennt euch jemand so in einem Plan, findet Pulsify euer Lokal.`)
};

/**
* | output |
* | --- |
* | "Separate several with commas. When someone calls you that in a plan, Pulsify finds your place." |
*
* @param {Listingnicknameshint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingnicknameshint2 = /** @type {((inputs?: Listingnicknameshint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingnicknameshint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingnicknameshint2(inputs)
	return de_listingnicknameshint2(inputs)
});
export { listingnicknameshint2 as "listingNicknamesHint" }